<template>
  <div class="listview-container px-2 py-2">
  <SelectionToolbar
    transition="slide-y-transition"
    :selection="selection"
    :count="count"
    :totalCount="totalCount"
    :selectAll="selectAll"
    :selectNone="selectNone"
    :actions="selectActions"
    :isLoading="isLoading"
    v-if="count > 0"
  />
    <SearchBox
      :headers="headers"
      :handleSearch="handleSearch"
      :handleReset="handleSearchReset"
      :searchFields="searchFields"
      :searchForm="searchForm"
      :updateSearchField="updateSearchField"
      :selectView="selectView"
      :hasMap="hasMap"
      :hasLine="hasLine"
      :hasCard="hasCard"
      :listView="listViewType"
      :quickSearch="quickSearch"
      :updateQuickSearch="updateQuickSearch"
      :pagination="pagination"
      :handleSort="handleSort"
    />
    <component
      :is="dynamicComponent"
      :items="items"
      :unfiltered="unfiltered"
      :selection="selection"
      :emitSelection="emitSelection"
      :hasActions="hasDataActions"
      :actions="dataActions"
      :headers="headers"
      :isLoading="isLoading"
      :pagination="pagination"
      :handleSort="handleSort"
      :updatePagination="updatePagination"
      :totalCount="totalCount"
    />

  </div>
</template>

<script>
import TableView from '@/components/list/TableView'
import CardView from '@/components/list/CardView'
import MapView from '@/components/list/MapView'
import StatView from '@/components/list/StatView'
import SelectionToolbar from '@/components/list/SelectionToolbar'
import SearchBox from '@/components/list/SearchBox'

export default {
  components: {
    gtable: TableView,
    gcard: CardView,
    gmap: MapView,
    gstat: StatView,
    SelectionToolbar,
    SearchBox,
  },
  props: {
    items: Array,
    unfiltered: Array,
    selection: Array,
    emitSelection: Function,
    handleSort: Function,
    updatePagination: Function,
    pagination: Object,
    selectAll: Function,
    selectNone: Function,
    listViewType: String,
    headers: Array,
    isLoading: Boolean,
    hasLine: {type: Boolean, default: false},
    hasCard: {type: Boolean, default: true},
    hasList: {type: Boolean, default: true},
    hasMap: Boolean,
    count: Number,
    totalCount: Number,
    dataActions: Array,
    selectActions: Array,
    hideListAlert: Function,
    selectView: Function,
    quickSearch: String,
    updateQuickSearch: Function,
    searchFields: Array,
    searchForm: Object,
    handleSearch: Function,
    handleSearchReset: Function,
    updateSearchField: Function,
  },
  computed: {
    dynamicComponent () {
      switch (this.listViewType) {
        case 'card':
          return 'gcard'
        case 'map':
          return 'gmap'
        case 'line':
          return 'gstat'
        default:
          return 'gtable'
      }
    },
    hasDataActions () {
      return this.dataActions !== undefined && this.dataActions.length > 0
    },
  },

}
</script>

<style scoped>
  .baselist-container .listview-container {
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>
